/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'linkDataSource.accessInstructions': '若要要求存取權，請連絡您的網站管理員。',
  'linkDataSource.accessRequired': '您無法存取此內容',
  'linkDataSource.accessRequiredWithSite': '您無法存取下列網站：',
  'linkDataSource.assets.configModal.aqlSearchInput.helpTooltipText': '語法說明',
  'linkDataSource.assets.configModal.aqlSearchInput.placeholder': '透過 AQL 搜尋',
  'linkDataSource.assets.configModal.objectSchemaSelect.label': '選取結構描述',
  'linkDataSource.assets.configModal.objectSchemaSelect.placeholder': '選取結構描述',
  'linkDataSource.assets.configModal.objectSchemaSelect.schemaRequired': '結構描述為必要項目',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.learnMoreLink': '進一步了解如何使用 JQL 進行搜尋。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchDescription': '開始輸入或使用 AQL 進行搜尋。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchTitle': '搜尋物件',
  'linkDataSource.assets.configmodal.insertIssuesButtonText': '{objectsCount, plural, other {插入物件}}',
  'linkDataSource.assets.configmodal.insertObjectsTitle': '插入物件來源：',
  'linkDataSource.assets.configmodal.updateObjectsButtonText': '更新表格',
  'linkDataSource.basic-filter.assignee.label': '受託人',
  'linkDataSource.basic-filter.dropdown.select.assignee.unassigned': '未指派',
  'linkDataSource.basic-filter.dropdown.select.placeholder': '搜尋',
  'linkDataSource.basic-filter.error-message': '發生錯誤',
  'linkDataSource.basic-filter.footer.pagination-details': '第 {currentDisplayCount} 個，共 {totalCount} 個',
  'linkDataSource.basic-filter.loading-message': '正在載入...',
  'linkDataSource.basic-filter.no-options-message': '找不到相符項目',
  'linkDataSource.basic-filter.project.label': '專案',
  'linkDataSource.basic-filter.showMoreButton': '顯示更多',
  'linkDataSource.basic-filter.status.label': '狀態',
  'linkDataSource.basic-filter.type.label': '類型',
  'linkDataSource.checkConnection': '請檢查您的連線並重新整理，或稍後再試一次。',
  'linkDataSource.clol-basic-filter.editedOrCreatedBy.label': '編輯者或建立者',
  'linkDataSource.column-picker.no-all-items-shown-message.line-1': '您的搜尋傳回過多結果。',
  'linkDataSource.column-picker.no-all-items-shown-message.line-2': '請使用更具體的關鍵字再試一次。',
  'linkDataSource.column-picker.search': '搜尋欄位',
  'linkDataSource.column-picker.tooltip': '設定欄',
  'linkDataSource.configmodal.basicTextSearchPlaceholder': '按關鍵字搜尋議題',
  'linkDataSource.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '按關鍵字搜尋工作項目',
  'linkDataSource.configmodal.cancelButtonText': '取消',
  'linkDataSource.confluence-search.configmodal.cancelButtonText': '取消',
  'linkDataSource.confluence-search.configmodal.date.range.after.label': '{date} 之後',
  'linkDataSource.confluence-search.configmodal.date.range.any.time': '任何時間',
  'linkDataSource.confluence-search.configmodal.date.range.before.label': '{date} 之前',
  'linkDataSource.confluence-search.configmodal.date.range.custom': '自訂',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.end': '開始日期必須在結束日期之前',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.today': '開始日期不能是未來',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.to.after.today': '結束日期不能是未來',
  'linkDataSource.confluence-search.configmodal.date.range.error': '日期範圍錯誤',
  'linkDataSource.confluence-search.configmodal.date.range.from': '從',
  'linkDataSource.confluence-search.configmodal.date.range.input.placeholder': '選擇日期',
  'linkDataSource.confluence-search.configmodal.date.range.last.month': '過去 30 天內',
  'linkDataSource.confluence-search.configmodal.date.range.last.week': '過去 7 天內',
  'linkDataSource.confluence-search.configmodal.date.range.last.year': '過去一年內',
  'linkDataSource.confluence-search.configmodal.date.range.title': '上次更新',
  'linkDataSource.confluence-search.configmodal.date.range.to': '到',
  'linkDataSource.confluence-search.configmodal.date.range.to.Label': '到',
  'linkDataSource.confluence-search.configmodal.date.range.today': '今天',
  'linkDataSource.confluence-search.configmodal.date.range.update.button': '更新',
  'linkDataSource.confluence-search.configmodal.date.range.yesterday': '昨天',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitle': '插入 Confluence 列表',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitleManySites': '插入 Confluence 列表的來源：',
  'linkDataSource.confluence-search.configmodal.insertResultsButtonText': '插入結果',
  'linkDataSource.confluence-search.configmodal.placeholder.issues': '### 項結果',
  'linkDataSource.confluence-search.configmodal.searchLabel': '輸入關鍵字以尋找頁面、附件等等',
  'linkDataSource.confluence-search.no.confluence.sites.access.description': '若要要求存取權，請連絡您的管理員。',
  'linkDataSource.confluence-search.no.confluence.sites.access.title': '您無法存取任何 Confluence 網站',
  'linkDataSource.datasource.table.authConnectButtonText': '連結',
  'linkDataSource.datasource.table.authScreenDescriptionText': '連接您的 {providerName} 帳戶，以在各個 Atlassian 產品上的工作協同合作。',
  'linkDataSource.datasource.table.authScreenHeaderText': '連結 {providerName} 帳戶',
  'linkDataSource.datasource.table.learnMoreAboutSmartLinks': '深入了解智慧連結。',
  'linkDataSource.issue-line-table.error-403-description': '您需要正確的權限才能編輯此項目。',
  'linkDataSource.issue-line-table.error-403-title': '未儲存變更',
  'linkDataSource.issue-line-table.error-generic-description': '我們在嘗試完成更新時遇到問題。請稍候數分鐘，然後再試一次。如果這種情況持續發生，請連絡支援團隊。',
  'linkDataSource.issue-line-table.error-generic-title': '發生錯誤',
  'linkDataSource.issue-line-table.fetch-action-error-generic-description': '請稍候數分鐘，然後再試一次。如果這種情況持續發生，請檢查您的專案設定或連絡支援團隊。',
  'linkDataSource.issue-line-table.fetch-action-error-generic-title': '我們在擷取選項時遇到問題',
  'linkDataSource.issue-line-table.unwrap-text': '取消文字換行',
  'linkDataSource.issue-line-table.wrap-text': '將文字換行',
  'linkDataSource.checkConnectionWithSource': '請檢查您的連線並重新整理，或者<a>在 Jira 中開啟此查詢</a>加以檢閱。',
  'linkDataSource.jira-issues.configmodal.basicModeSwitchDisabledTooltipText': '您無法針對此查詢切換為基本模式。',
  'linkDataSource.jira-issues.configmodal.basicModeText': '基本',
  'linkDataSource.jira-issues.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '按關鍵字搜尋工作項目',
  'linkDataSource.site-selector.configmodal.chooseSite': '選擇網站',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText': '插入議題',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText-issue-term-refresh': '插入工作項目',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle': '插入 Jira 議題',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle-issue-term-refresh': '插入 Jira 工作項目',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites': '從中插入 Jira 議題：',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites-issue-term-refresh': '從中插入 Jira 工作項目：',
  'linkDataSource.jira-issues.configmodal.placeholder.issues-issue-term-refresh': '### 個工作項目',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkDescription': '將搜尋結果數目顯示為內嵌智慧連結',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkLabel': '內嵌連結',
  'linkDataSource.jira-issues.configmodal.viewModeListDescription': '將搜尋結果顯示為列表',
  'linkDataSource.jira-issues.configmodal.viewModeListLabel': '列表',
  'linkDataSource.jira-issues.learnMoreLink': '了解如何使用 JQL 搜尋',
  'linkDataSource.no.jira.sites.access.description': '若要要求存取權，請連絡您的管理員。',
  'linkDataSource.no.jira.sites.access.title': '您無法存取任何 Jira 網站',
  'linkDataSource.noResultsFound': '找不到結果',
  'linkDataSource.refresh': '重新整理',
  'linkDataSource.jira-issues.searchDescription-basic': '按關鍵字搜尋，以插入議題。',
  'linkDataSource.jira-issues.searchDescription-jql': '使用 JQL (Jira 查詢語言) 來搜尋議題。',
  'linkDataSource.jira-issues.searchJiraTitle': '搜尋 Jira 議題',
  'linkDataSource.unableToLoadItems': '無法載入項目',
  'linkDataSource.unableToLoadResults': '無法載入結果',
  'linkDataSource.modal-initial-state.beta': '測試版',
  'linkDataSource.modal-initial-state.confluenceSearchTitle': '搜尋 Confluence 頁面',
  'linkDataSource.modal-initial-state.jiraSearchTitle': '搜尋 Jira 議題',
  'linkDataSource.modal-initial-state.searchDescription-basic-issue-term-refresh': '按關鍵字搜尋要插入的工作項目。',
  'linkDataSource.modal-initial-state.searchDescription-confluence': '按關鍵字搜尋要插入的頁面。',
  'linkDataSource.modal-initial-state.searchDescription-jql-issue-term-refresh': '使用 JQL (Jira 查詢語言) 來搜尋工作項目。',
  'linkDataSource.modal-initial-state.searchTitle-issue-term-refresh': '搜尋 Jira 工作項目',
  'linkDataSource.render-type.boolean.false': '否',
  'linkDataSource.render-type.boolean.true': '是',
  'linkDataSource.render-type.user.default.display.name': '未指派',
  'linkDataSource.search.configmodal.issueCountText': '{searchCount, plural, other {{searchCount,number} 個議題}}',
  'linkDataSource.search.configmodal.issueCountText-issue-term-refresh': '{searchCount, plural, other {{searchCount,number} 個工作項目}}',
  'linkDataSource.search.configmodal.itemCountText': '{searchCount, plural, other {{searchCount,number} 個項目}}',
  'linkDataSource.search.configmodal.resultCountText': '{searchCount, plural, other {{searchCount,number} 項結果}}',
  'linkDataSource.table-footer.date_formatter.under_one_minute': '剛才已同步',
  'linkDataSource.table-footer.date_formatter.under_over_minute': '已於 {date} 同步',
  'linkDataSource.table-footer.item': '{itemCount, plural, other {個項目}}',
  'linkDataSource.table-footer.loading': '正在載入...',
  'linkDataSource.table-footer.power-by-jsm': '由 Jira Service Management 中的 Assets 提供技術支援',
  'linkDataSource.table-footer.powered-by-assets': '由 Assets 提供技術支援',
  'linkDataSource.table-footer.refresh': '重新整理'
};